(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["model-viewer"] && !Shopify.designMode) return;
  try {
    const container = document.querySelector('.product__model-selector-list');
  if (!container) return;
  const items = document.querySelectorAll('.product__model');
  if (!items.length) return;
  const mediaGallery = container.closest('.product__media-wrapper');
  if (!mediaGallery) return;
  const mobileSlider = mediaGallery.querySelector('.slider--mobile');
  if (!mobileSlider) return;

  container.addEventListener('click', (e) => {
    e.preventDefault();
    container.classList.toggle('product__model-selector-list--open');
  });

  function activateItem(item) {
    let isBefore = true;

    items.forEach((i) => {
      const isActive = i === item;
      i.classList.toggle('product__model--active', isActive);

      if (isActive) {
        isBefore = false;
      }

      i.classList.toggle('product__model--before', isBefore);
    });

    container.classList.remove('product__model-selector-list--open');
  }

  items.forEach((item) => {
    item.addEventListener('click', (e) => {
      e.stopPropagation();
      activateItem(item);

      const isDesktop = window.matchMedia('(min-width: 749px)').matches;

      const selector = item.getAttribute('data-selector');
      if (!selector) return;

      const image = document.querySelector(`[id="${selector}"]`);
      if (!image) return;

      image.scrollIntoView({
        block: 'nearest',
        inline: 'nearest',
        behavior: 'smooth',
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-complete-the-look"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const containers = document.querySelectorAll('[data-complete-look]');

    for (const container of containers) {
      const trigger = container.querySelector('[data-atc-trigger]');
      const form = container.querySelector('[data-complete-look-form]');
      const variantButtons = container.querySelectorAll('[data-variant-button]');

      if (!form || !trigger) return;

      trigger.addEventListener('click', () => {
        form.classList.add('complete-look__form--active');
      });

      container.addEventListener('mouseleave', () => {
        form.classList.remove('complete-look__form--active');
      });

      for (const button of variantButtons) {
        let timeoutId = null;

        button.addEventListener('click', () => {
          if (timeoutId) {
            clearTimeout(timeoutId);
          }

          button.classList.add('complete-look__variant-button--active');

          timeoutId = setTimeout(() => {
            button.classList.remove('complete-look__variant-button--active');
            timeoutId = null;
          }, 1000);
        });
      }
    }
  });
  } catch(e) { console.error(e); }
})();

})();
